module.exports = __webpack_public_path__ + "img/text_03.dc2c09de.png";